import styled from 'styled-components';
import { FlexColumn, FlexSpace } from '@elementary/common-ui/components';
import { Slider, Typography } from '@mui/material';

const StyledSlider = styled(Slider)<{ $sliderValues: number[] }>`
  & .MuiSlider-track {
    color: ${({ theme }) => theme.palette.common.orange100};
    height: 4px;
  }
  & .MuiSlider-thumb {
    height: 20px;
    width: 4px;
    background-color: ${({ theme }) => theme.palette.common.black};
    border-radius: 8px;
  }
  & .MuiSlider-rail {
    background: ${({ theme, $sliderValues }) =>
      `linear-gradient(to right, ${theme.palette.common.red100} 0% ${$sliderValues[0]}%, ${theme.palette.common.green100} ${$sliderValues[1]}% 100%)`};
    opacity: 1;
    height: 4px;
  }
  & .MuiSlider-valueLabel {
    width: 40px;
    height: 21px;
    padding: 8px;
    border-radius: 8px;
    font-size: 12px;
    line-height: normal;
    background-color: ${({ theme }) => theme.palette.common.black};
    top: 47px;
    &:before {
      display: none;
    }
  }
`;

type Props = {
  sliderValues: number[];
  onChange: (sliderValues: number[]) => void;
};

const ScoreThresholdsSlider = ({ sliderValues, onChange }: Props) => (
  <FlexColumn>
    <Typography
      sx={{
        paddingBottom: '16px',
        fontSize: '16px',
        fontWeight: '500',
        lineHeight: 'normal',
      }}
    >
      Score Thresholds
    </Typography>
    <StyledSlider
      $sliderValues={sliderValues}
      valueLabelDisplay="on"
      valueLabelFormat={(x) => `${x}%`}
      value={sliderValues}
      min={0}
      max={100}
      onChange={(_event: Event, eventValues: number[] | number) =>
        onChange(eventValues as number[])
      }
    />
    <FlexSpace>
      <Typography>0</Typography>
      <Typography>100</Typography>
    </FlexSpace>
  </FlexColumn>
);

export default ScoreThresholdsSlider;
